import React from 'react';
import countries from '../../../../assets/data/Countries';
import { AvField, AvGroup } from 'availity-reactstrap-validation';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const CountryField = ({ object, ...props }) => {
  const intl = useIntl();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  return (
    <AvGroup className="form-label-group">
      <AvField
        type="select"
        name="country"
        id="country"
        className="with-dropdown-icon"
        value={
          object?.country?.toUpperCase() ||
          query?.get('country')?.toUpperCase() ||
          (intl?.locale.toUpperCase() === 'EN'
            ? 'US'
            : intl?.locale.toUpperCase()) ||
          'DE'
        }
        {...props}
      >
        {Object.keys(countries).map((key) => (
          <option key={key} value={key}>
            {countries[key]?.name}
          </option>
        ))}
      </AvField>
    </AvGroup>
  );
};

CountryField.propTypes = {
  object: PropTypes.object,
};

export default CountryField;
